import { render, staticRenderFns } from "./EditLocations.vue?vue&type=template&id=06c78464&"
import script from "./EditLocations.vue?vue&type=script&lang=js&"
export * from "./EditLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports